// Cookie and JWT helpers shared by AuthContext and accessTokenLoop.

export function setCookie(key: string, value: string, expMs: number): void {
  const expires = new Date(expMs).toUTCString();
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${key}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Strict${secure}`;
}

export function getCookie(key: string): string | undefined {
  const match = document.cookie.match(new RegExp(`(?:^|; )${key}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : undefined;
}

export function deleteCookie(key: string): void {
  document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Strict`;
}

// JWT decode — no dependency; the signature is not verified client-side.

export interface JwtPayload {
  sub: string;
  email?: string;
  EMAIL?: string;
  GIVEN_NAME?: string;
  FAMILY_NAME?: string;
  display_name?: string;
  ldap_groups?: string[];
  exp: number;
  iat?: number;
  iss?: string;
  aud?: string;
  nonce?: string;
}

export function decodeJwt(token: string): JwtPayload {
  const parts = token.split('.');
  if (parts.length !== 3) throw new Error('Invalid JWT format');
  const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
  const padded = payload + '='.repeat((4 - (payload.length % 4)) % 4);
  // Use TextDecoder for proper UTF-8 multi-byte support (e.g. CJK display names)
  const bytes = Uint8Array.from(atob(padded), (c) => c.charCodeAt(0));
  return JSON.parse(new TextDecoder().decode(bytes));
}
